import { motion } from "motion/react";

// AI platforms where SEOintent helps you get cited/surfaced.
// Each entry needs a reliable logo src — when it fails the ENTIRE item hides.
const aiEngines = [
  {
    name: "ChatGPT",
    src: "https://upload.wikimedia.org/wikipedia/commons/0/04/ChatGPT_logo.svg",
  },
  {
    name: "Claude",
    src: "https://upload.wikimedia.org/wikipedia/commons/1/14/Anthropic.png",
  },
  {
    name: "Gemini",
    src: "https://upload.wikimedia.org/wikipedia/commons/8/8a/Google_Gemini_logo.svg",
  },
  {
    name: "Perplexity",
    src: "https://upload.wikimedia.org/wikipedia/commons/1/1d/Perplexity_AI_logo.svg",
  },
  {
    name: "Copilot",
    src: "https://upload.wikimedia.org/wikipedia/commons/d/d3/Microsoft_Copilot_Icon.svg",
  },
  {
    name: "Meta AI",
    src: "https://upload.wikimedia.org/wikipedia/commons/7/7b/Meta_Platforms_Inc._logo.svg",
  },
  {
    name: "Google",
    src: "https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_logo.svg",
  },
  {
    name: "Grok",
    src: "https://upload.wikimedia.org/wikipedia/commons/a/a5/Grok.svg",
  },
];

export const AIEnginesMarquee = () => {
  return (
    <div className="py-12 border-y border-zinc-200 bg-gradient-to-r from-[#FF2F2F]/[0.02] via-white to-[#FF2F2F]/[0.02] overflow-hidden">
      <div className="container mx-auto px-4 mb-8 text-center">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-400 mb-2">
          Get cited &amp; surfaced across every AI answer engine
        </p>
        <p className="text-sm text-zinc-600">
          SEOintent optimizes your content for the engines people actually ask
        </p>
      </div>
      <div className="flex overflow-hidden">
        <motion.div
          className="flex gap-20 items-center whitespace-nowrap"
          animate={{ x: [0, -1600] }}
          transition={{ duration: 28, repeat: Infinity, ease: "linear" }}
        >
          {[...aiEngines, ...aiEngines, ...aiEngines].map((engine, i) => (
            <div
              key={i}
              className="flex items-center shrink-0 grayscale hover:grayscale-0 opacity-70 hover:opacity-100 transition-all duration-300"
              title={engine.name}
            >
              <img
                src={engine.src}
                alt={engine.name}
                className="h-8 md:h-10 w-auto object-contain"
                referrerPolicy="no-referrer"
                onError={(e) => {
                  // Hide the whole item — not just the img — so no orphans appear
                  e.target.closest("div").style.display = "none";
                }}
              />
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};
